import { render, staticRenderFns } from "./TeachinSection.vue?vue&type=template&id=387d7d18&scoped=true&"
import script from "./TeachinSection.vue?vue&type=script&lang=js&"
export * from "./TeachinSection.vue?vue&type=script&lang=js&"
import style0 from "./TeachinSection.vue?vue&type=style&index=0&id=387d7d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d7d18",
  null
  
)

export default component.exports